import { type GetSegmentsQueryParams } from '@gonfalon/openapi/operations/getSegments';

import { createQueryHook } from '../internal/createQueryHook';
import { segments } from '../queries/segments';

export const useSegments = createQueryHook(
  ({
    projectKey,
    environmentKey,
    params,
    batch,
    apiVersion,
  }: {
    projectKey: string;
    environmentKey: string;
    params?: GetSegmentsQueryParams;
    batch?: boolean;
    apiVersion?: string;
  }) => {
    return segments.list({ projectKey, environmentKey, params, batch, apiVersion });
  },
);
